import { convertToCamelCase } from '@vista-digital/utilities';
import { FieldFormatType } from '../../types/form/field-format-type';
import { FieldValidationError } from '../../types/form/field-validation-error';
import { isStandardFieldValidationResult } from '../../utils/form/field-validation-result';
import { InputFieldInternalAction } from './field/input/types/internal-action';
/**
 * Parses and returns the display text for a FieldValidationResult.
 * displayText keys contain a single field per validation error type in the format: displayText[`${validationError}Message`]
 */
export const getFormFieldErrorMessage = (errorResult, displayText, i18n, config, templateParameters, formDisplayText, accessibilityText) => {
    const { error, value } = isStandardFieldValidationResult(errorResult)
        ? errorResult
        : { error: errorResult, value: undefined };
    if (!error) {
        return undefined;
    }
    let errorDisplayText = displayText[`${convertToCamelCase(error)}Message`] || error;
    if (error === FieldValidationError.Length) {
        errorDisplayText = getFormattedLengthErrorMessage(config, errorDisplayText, i18n);
    }
    if (error === FieldValidationError.Range) {
        errorDisplayText = getFormattedRangeErrorMessage(config, errorDisplayText, i18n);
    }
    if (error === FieldValidationError.EmailSuggestion) {
        errorDisplayText = getFormattedEmailSuggestionErrorMessage(config, value, formDisplayText, accessibilityText);
    }
    if (templateParameters) {
        errorDisplayText = i18n.displayTextLabel(errorDisplayText, templateParameters);
    }
    return errorDisplayText;
};
export const getFormattedLengthErrorMessage = (fieldConfig, errorText, i18n) => {
    if (!fieldConfig || !isRestrictedLengthFieldValidationConfig(fieldConfig)) {
        return errorText;
    }
    const templateParameters = {
        minLength: fieldConfig.minLength,
        maxLength: fieldConfig.maxLength
    };
    return i18n.displayTextLabel(errorText, templateParameters);
};
export const getFormattedRangeErrorMessage = (fieldConfig, errorText, i18n) => {
    var _a, _b;
    if (!fieldConfig || !isRangeFieldValidationConfig(fieldConfig)) {
        return errorText;
    }
    const templateParameters = {
        min: (_a = fieldConfig.range) === null || _a === void 0 ? void 0 : _a.min,
        max: (_b = fieldConfig.range) === null || _b === void 0 ? void 0 : _b.max
    };
    return i18n.displayTextLabel(errorText, templateParameters);
};
export const getFormattedEmailSuggestionErrorMessage = (fieldConfig, suggestedEmail, formDisplayText, accessibilityText) => {
    if (!suggestedEmail || !formDisplayText || !accessibilityText) {
        return undefined;
    }
    if (!fieldConfig || !isEmailFieldValidationConfig(fieldConfig)) {
        return undefined;
    }
    const token = '${suggestedEmail}';
    const index = formDisplayText.emailSuggestionFormat.indexOf(token);
    if (index === -1) {
        return {
            text: formDisplayText.emailSuggestionFormat,
            className: 'suggestion-text'
        };
    }
    const prefix = formDisplayText.emailSuggestionFormat.substring(0, index);
    const suffix = formDisplayText.emailSuggestionFormat.substring(index + token.length);
    const suggestionText = [];
    if (prefix.length) {
        suggestionText.push({
            text: prefix,
            className: 'suggestion-text'
        });
    }
    suggestionText.push({
        text: suggestedEmail,
        className: 'suggested-value',
        internalAction: InputFieldInternalAction.AcceptEmailSuggestion
    });
    if (suffix.length) {
        suggestionText.push({
            text: suffix,
            className: 'suggestion-text'
        });
    }
    return suggestionText;
};
const isRestrictedLengthFieldValidationConfig = (config) => {
    return 'minLength' in config || 'maxLength' in config;
};
const isRangeFieldValidationConfig = (config) => {
    return 'range' in config;
};
export const isEmailFieldValidationConfig = (config) => {
    return config.type === FieldFormatType.Email;
};
//# sourceMappingURL=form-field-utils.js.map